const MILES_TO_METERS = 1609.34

export const milesToMeters = miles => miles * MILES_TO_METERS
export const metersToMiles = meters => meters / MILES_TO_METERS
